import React from 'react';
import { IconProps } from './types/Icon.type';

function TopbarSearchIcon(props: IconProps) {
  return (
    <svg
      width={props.boxSize ?? '32'}
      height={props.boxSize ?? '32'}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5 14.5C20.5 18.0899 17.5899 21 14 21C10.4101 21 7.5 18.0899 7.5 14.5C7.5 10.9101 10.4101 8 14 8C17.5899 8 20.5 10.9101 20.5 14.5ZM19.1018 20.6624C17.717 21.8101 15.9391 22.5 14 22.5C9.58172 22.5 6 18.9183 6 14.5C6 10.0817 9.58172 6.5 14 6.5C18.4183 6.5 22 10.0817 22 14.5C22 16.4391 21.3101 18.217 20.1624 19.6018L25.0303 24.4697C25.3232 24.7626 25.3232 25.2374 25.0303 25.5303C24.7374 25.8232 24.2626 25.8232 23.9697 25.5303L19.1018 20.6624Z"
        fill={props.fill ?? '#121212'}
      />
    </svg>
  );
}

export default TopbarSearchIcon;
